export const truncate = (input: string, length: number) => {
  input = (input ?? '');
  return input.substring(0, length - 1) + (input.length > length ? '...' : '');
};
